import styled from 'styled-components';
import { caption, colors, spacing } from 'ui/theme';

export const FooterContainer = styled.div`
  display: flex;
  padding: ${spacing.threeQuarter} ${spacing.base};
  background: ${colors.backgroundSecondary};
  justify-content: space-between;
  align-items: center;
  border-top: ${spacing.single} solid ${colors.borderPrimarySubtle};
  border-radius: 0 0 ${spacing.half} ${spacing.half};
  ${caption}
`;

export const Count = styled.div`
  color: ${colors.textSecondary};
`;

export const FooterShortcut = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.quarter};
  color: ${colors.textDisabled};
  margin-left: auto;
`;
